var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DialogTeamSelect',{attrs:{"description":"Choose your active team","title":'Join \'' + _vm.quizName + '\''},on:{"ok":_vm.joinQuiz},model:{value:(_vm.teamDialog),callback:function ($$v) {_vm.teamDialog=$$v},expression:"teamDialog"}})}
var staticRenderFns = []

export { render, staticRenderFns }